module.exports = __webpack_public_path__ + "media/application/images/ui/icon-minus-a3f2ba5262c037a9b6b3d7e1a5b21ce2.png";